import { render } from "./Forum-edit.vue?vue&type=template&id=39f76987&scoped=true&lang=pug"
import script from "./Forum-edit.vue?vue&type=script&setup=true&lang=js"
export * from "./Forum-edit.vue?vue&type=script&setup=true&lang=js"

import "./Forum-edit.vue?vue&type=style&index=0&id=39f76987&scoped=true&lang=css"

import exportComponent from "E:\\D\\web\\pyCharm\\arhichat-3.4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39f76987"]])

export default __exports__